import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = {
  class: "d-flex justify-content-center",
  style: {"padding-top":"200px"}
}
const _hoisted_2 = {
  key: 0,
  class: "card"
}
const _hoisted_3 = {
  key: 1,
  class: "card"
}
const _hoisted_4 = { class: "card-body" }
const _hoisted_5 = { class: "card-text lead" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      (!_ctx.errorMessage)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [...(_cache[0] || (_cache[0] = [
            _createElementVNode("div", { class: "card-body" }, [
              _createElementVNode("h5", { class: "card-title" }, [
                _createElementVNode("i", { class: "fa fa-spinner fa-spin" }),
                _createTextVNode(" Loading...")
              ])
            ], -1 /* CACHED */)
          ]))]))
        : _createCommentVNode("v-if", true),
      (_ctx.errorMessage)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _cache[1] || (_cache[1] = _createElementVNode("h5", { class: "card-title" }, "Access denied", -1 /* CACHED */)),
              _createElementVNode("p", _hoisted_5, _toDisplayString(_ctx.errorMessage), 1 /* TEXT */),
              _cache[2] || (_cache[2] = _createElementVNode("br", null, null, -1 /* CACHED */))
            ])
          ]))
        : _createCommentVNode("v-if", true)
    ])
  ]))
}